
/**
 * 页面-->弹窗
 */
export enum PAGE {
  INGAMEPAGE = "InGamePage",
  WINPAGE = "prefab/WinPage",
  LOSEPAGE = "prefab/LosePage",
  LEVELMENU = "LevelMenu",
  PAUSEPAGE = "PausePage",
  TIPSPAGE = "TipsShowPage",
  MODEMENU = "ModeMenu",
  UNLOCKPAGE = "UnLockPage",
  TERRORPAGE = 'prefab/TerrorPage',
  SETUP = 'SetUp',
  TIPSSinglePAGE = 'TipsSingleShowPage',
  ADDCLICKTIMES = 'AddClickTimes',
}


/**
 * 游戏事件
 */
export enum GAME_EVENT {
  ON_BTN_TIPS = "onBtnTips",
  ON_BTN_ANSWER = "onBtnAnswer",
  ON_TIPS_GOT = "onTipsGot",
  ON_ANSWER_GOT = "onAnswerGot",
  /**游戏恢复 */
  GAME_RESUME = "gameResume",
  /**游戏暂停 */
  GAME_PAUSE = "gamePause",
  /**改变标题 */
  CHANGE_TITLE = 'change-title',


  ON_GAME_END = 'onGameOver',
}

/**
 * 触摸事件
 */
export enum TOUCH_TYPE {
  SINGLE = 0,
  DOUBLE_SLIDER = 1,
  DOUBLE_ZOOM = 2,
  DOUBLE_ROT = 3,
}


/**
 * 音效/震动开关
 */
export enum SWITCH_TYPE {
  MUSIC = 'MusicSwitch',
  SOUND = "SoundSwitch",
  VIBRATE = "VirSwitch",
}
